// "Resend code" for texted codes, with a cool-down: every text costs money and counts
// against carrier limits, so impatient double-clicks mustn't send a burst.
import React, { useEffect, useState } from 'react';
import './ResendCodeButton.css';

export const RESEND_SECONDS = 30;

export default function ResendCodeButton({ onResend, onError, seconds = RESEND_SECONDS }) {
  const [left, setLeft] = useState(seconds);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (left <= 0) return undefined;
    const timer = setTimeout(() => setLeft((value) => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [left]);

  const resend = async () => {
    setSending(true);
    try {
      await onResend();
      setLeft(seconds);
    } catch (err) {
      onError?.(err);
    } finally {
      setSending(false);
    }
  };

  let label = 'Resend code';
  if (sending) label = 'Sending…';
  else if (left > 0) label = `Resend code in ${left}s`;
  return (
    <button type="button" className="resend-code-button" onClick={resend} disabled={sending || left > 0}>
      {label}
    </button>
  );
}
